// src/api/home/monthlySalesApi.js
import axiosClient from '../axiosClient';

export const monthlySalesApi = {

    getMonthlySales: async (type, category) => {
        const params = new URLSearchParams({ type });
        if (category) params.append('category', category);
        const data = await axiosClient.get(`/monthly-sales?${params.toString()}`);
        return data || [];
    },

    getDailySales: async ({ type, month, year, category, customer, salesperson }) => {
        const params = new URLSearchParams({ type, month, year });
        if (category)    params.append('category',    category);
        if (customer)    params.append('customer',    customer);
        if (salesperson) params.append('salesperson', salesperson);
        const data = await axiosClient.get(`/monthly-sales/daily?${params.toString()}`);
        return data || { dailyData: [] };
    },

    getCategories: async () => {
        const data = await axiosClient.get('/monthly-sales/categories');
        return data?.categories || [];
    },
};